import styled from "styled-components";

export const Container = styled.div `
    width: 100%;
    max-width: 1200px;
    margin: auto;

    
    .show-string {
        margin-left: 10px;
        width: 30px;
        height: 30px;
        background: #404040;
        cursor: pointer;
        color: #fff;
        border-radius: 50%;
        border: none;
    }

    .show-string:hover {
        background: #505050;
    }

`

export const Section = styled.header `
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 3px solid #505050;
    
    h2 {
        margin-bottom: 10px;
        position: relative;
    }

    h4 {
        font-size: 1.3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    h4 img {
        width: 20px;
        margin: 0 0 -2px 0;
    }

    p, .account-created {
        font-size: .8rem;
        font-weight: 500;
    }
`

export const Header = styled.header `
    display: flex;
    align-items: center;

    button {
        height: 40px;
        width: 40px;
        border-radius: 50px;
        background: #404040;
        font-size: 1.1rem;
        cursor: pointer;
        color: #fff;
        border: none;
        margin-right: 10px;
        transition: all .3s ease;
    }

    button:hover {
        background: #505050;
    }

    h3 {
        font-size: 1.5rem;
    }
`

export const ModalDeleteAccount = styled.div `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #181818;
    height: 100%;
    z-index: 2;
`

export const Main = styled.main `
    margin-top: 50px;
`

export const AbboutAccount = styled.main `

    h2 {
        position: relative;
        margin-bottom: 20px;
    }

    h4 {
        font-size: 1.3rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }

    .email, .account-created {
        font-size: .8rem;
        font-weight: 500;
    }

    @media (max-width: 400px) {
        h2 {
            font-size: 1.2rem;
        }

        h4 {
            font-size: 1rem;
            margin-bottom: 5px;
        }

        .email, .account-created {
            font-size: .7rem;
        }
    }

`

export const Profiles = styled.div `
    padding-top: 20px;

    footer {
        display: flex;
        margin: 20px 0;
    }
    
    footer a {
        text-align: center;
        padding: 12px 20px;
        border-radius: 50px;
        background: #303030;
        color: #fff;
        font-weight: 600;
        font-size: .9rem;
        margin: 0 5px 0 0;
        border: none;
        transition: all .3s ease;
    }
    
    footer a:hover {
        background: #404040;
    }
    
    footer button {
        text-align: center;
        padding: 12px 20px;
        border-radius: 50px;
        background: red;
        color: #fff;
        font-weight: 600;
        font-size: .9rem;
        margin: 0 5px 0 0;
        border: none;
        cursor: pointer;
        transition: all .3s ease;
    }
    
    footer button:hover {
        opacity: .8;
    }

    @media (max-width: 800px) {
        footer {
            display: flex;
            flex-direction: column;
            margin: 20px 0;
        }
    
        footer button, footer a {
            text-align: center;
            padding: 15px 20px;
            border-radius: 5px;
            margin: 0 0 5px 0;
        }
    }
    
`

export const ContentProfileActual = styled.div `
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 600px) {
        flex-direction: column;
        align-items: start;
    }
`

export const ContentProfile = styled.div `
    width: 100%;
    margin: 20px 0;
    display: flex;
    align-items: center;

    .loading {
        margin: auto;
    }

    .new-profile {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        margin-left: 10px;
        background: #303030;
        color: #fff;
        font-weight: 600;
        font-size: 1rem;
        border-radius: 5px;
        max-width: 200px;
        transition: all .3s ease;
    }

    .new-profile:hover {
        background: #454545;
    }

    .new-profile i {
        margin-right: 5px;
    }

    @media (max-width: 1000px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr); /* Dois itens por linha */
        gap: 10px;
    }

    @media (max-width: 600px) {
        display: grid;
        grid-template-columns: repeat(1, 1fr); /* Dois itens por linha */
        gap: 5px;

        .new-profile {
            max-width: 100%;
            margin: 0;
        }
    }

`

export const Profile = styled.button `
    display: flex;
    align-items: start;
    justify-content: space-between;
    margin: 5px 5px 10px 0;
    background: unset;
    color: #fff;
    border: none;
    cursor: ${props => props.isDisabled ? 'default' : 'pointer'};
    padding: 10px 20px 10px 10px;
    transition: all .3s ease;

    &:hover {
        background: ${props => props.isDisabled ? 'unset' : '#222222'};
    }

    section {
        display: flex;
        align-items: center;
    }

    div {
        display: flex;
        flex-direction: column;
        align-items: start;
    }

    img {
        background: #303030;
        width: 60px;
        border-radius: 5px;
        margin-right: 5px;
    }
    
    .div-icon-device {
        margin-right: 10px;
    }

    .div-icon-device i {
        font-size: 2rem;
    }

    .span-main-account {
        font-size: .65rem;
        font-weight: bold;
        margin-bottom: 3px;
    }

    .name {
        font-weight: 600;
        font-size: .9rem;
        text-align: start;
    }

    .last-login {
        font-weight: 600;
        font-size: .7rem;
        margin-bottom: 2px;
    }

    .profile-created {
        font-size: .7rem;
        color: #ccc;
        font-weight: 500;
        text-align: start;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    .actual-profile {
        display: flex;
        align-items: center;
        margin-left: 5px;
        font-size: 1rem;
    }

    @media (max-width: 600px) {
        margin: 0;
    }
`